import { render, staticRenderFns } from "./PopupConsentimento.vue?vue&type=template&id=4989e680&scoped=true&"
import script from "./PopupConsentimento.vue?vue&type=script&lang=js&"
export * from "./PopupConsentimento.vue?vue&type=script&lang=js&"
import style0 from "./PopupConsentimento.vue?vue&type=style&index=0&id=4989e680&prod&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4989e680",
  null
  
)

export default component.exports